export type PopupMapLpuItem = {
  coords: [number | string, number | string]
  phone?: string
  name: string
  address: string
  id: number | string
  lpuHref: string
}

type PopupMapOpenHandler = (_lpusData: PopupMapLpuItem[]) => void

let openHandler: PopupMapOpenHandler | null = null
let pendingLpusData: PopupMapLpuItem[] | null = null

/**
 * Регистрирует открытие карты через инстанс PopupMap на странице.
 *
 * Клик до монтирования хоста не теряется: payload кладётся в очередь.
 */
export function registerPopupMapOpen(handler: PopupMapOpenHandler) {
  openHandler = handler

  if (!pendingLpusData) {
    return
  }

  handler(pendingLpusData)
  pendingLpusData = null
}

export function unregisterPopupMapOpen(handler: PopupMapOpenHandler) {
  if (openHandler !== handler) {
    return
  }

  openHandler = null
}

/**
 * Открывает интерактивную карту PopupMap.
 *
 * Вызывает хост на странице напрямую, без window-события:
 * на `/ssr-vue-page` слушатель mixin появляется только после async-импорта.
 */
export default function openPopupMap(lpusData: PopupMapLpuItem[]) {
  if (!process.env.IS_CLIENT || !lpusData.length) {
    return
  }

  window.history.pushState(null, '', new URL('', window.location.href))

  if (openHandler) {
    openHandler(lpusData)

    return
  }

  pendingLpusData = lpusData
}
